import { DateTime } from 'luxon';
import { LevelTableCellProps, LevelTableHeaderProps } from 'redesign';
export enum paymentStates {
  BLOCKED = 'blocked',
  CREATED = 'created',
  READY_FOR_EARLY_PAYOUT = 'readyForEarlyPayout',
  READY_FOR_AUTOMATIC_PAYOUT = 'readyForAutomaticPayout',
  PAID_EARLY = 'paidEarly',
  PAID_AUTOMATICALLY = 'paidAutomatically',
}
type FailureReason = { date: string; reason: string };

export type getPaymentsData = {
  workerName: string;
  id: string;
  creationDate?: string;
  reference?: string;
  status: string;
  dueDate?: string;
  invoiceUrl?: string | null;
  failureReason?: FailureReason | null;
};
export type PaymentsParsedData = {
  workerName: string;
  paymentId: string;
  creationDate?: DateTime;
  status: string;
  dueDate?: DateTime;
  invoice?: { invoiceUrl: string; invoiceReference: string };
  actions: { paymentId: string };
  failureReason?: FailureReason | null;
};

export enum PaymentOrderBy {
  creationDate = 'creationDate',
  invoice = 'invoice',
}

export type PaymentsColumnDefinition = PaymentsParsedData;
export type PaymentsCellProp<T extends keyof PaymentsColumnDefinition> = LevelTableCellProps<
  PaymentsColumnDefinition,
  PaymentsColumnDefinition[T],
  PaymentsTableOptions
>;

export type PaymentsTableOptions = {
  getRowActions: (paymentId: string) => React.ReactNode[];
  sortState: 'asc' | 'desc';
  orderBy: PaymentOrderBy;
  onSortClick: (
    cell: LevelTableHeaderProps<PaymentsColumnDefinition, PaymentsTableOptions>
  ) => void;
};
